<template>
  <label class="image-checkbox__item image-checkbox__item--modal" :class="{ 'image-checkbox__item--active': checked }" :for="fieldId">
    <div class="d-flex">
      <div class="flex-fill">
        <input @input="check"
               type="checkbox"
               :checked="checked"
               :id="fieldId"
               :disabled="disabled"
               v-bind="$attrs"
               :name="fieldId"
               class="form-check-input image-checkbox__checkbox"/>
      </div>
      <div class="flex-fill text-end">
        <i v-if="option.description"
           ref="descriptionIcon"
           class="icon icon--md icon-question-circle"
           role="tooltip"
           :aria-label="option.description"
           @click.stop
           @touchend.stop.prevent="handleTouchEnd"></i>
      </div>
    </div>
    <div class="image-checkbox__image">
      <SvgIcon :path="`car-bodies/${option.iconName}`" alt="Osobní" :width="162" :height="50" />
    </div>
    <div class="text-center">
      <div class="text-gray-700 small">{{ option.label }}</div>
      <div class="text-gray-600 smaller">({{ option.count }})</div>
    </div>
  </label>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { Popover } from 'bootstrap';
import SvgIcon from './general/BaseSvgIcon.vue'

export default {
  name: 'FormImageCheckbox',
  emits: ["toggled"],
  components: {
    SvgIcon
  },
  props: {
    option: {
      type: Object,
      required: true,
    },
    fieldId: {
      type: String,
      default: () => `radio-image-${Math.random().toString(36).slice(7)}`,
    },
    selected: {
      type: Object,
      required: true,
    }
  },
  setup(props, context) {
    const checked = computed(() => props.selected && props.selected.name === props.option.name)
    const disabled = computed(() => props.option.count <= 0)
    const check = () => {
      context.emit("toggled", props.option);
    }

    const descriptionIcon = ref(null)
    let popoverInstance = null
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    onMounted(() => {
      if (!descriptionIcon.value || !props.option.description) return
      popoverInstance = new Popover(descriptionIcon.value, {
        content: props.option.description,
        trigger: isTouchDevice ? 'manual' : 'hover focus',
        placement: 'bottom',
      })
      if (isTouchDevice) {
        descriptionIcon.value.addEventListener('shown.bs.popover', () => {
          setTimeout(() => popoverInstance?.hide(), 3 * 1000)
        })
      }
    })

    onBeforeUnmount(() => {
      popoverInstance?.dispose()
    })

    const handleTouchEnd = () => {
      popoverInstance?.toggle()
    }

    return {
      checked,
      disabled,
      check,
      descriptionIcon,
      handleTouchEnd,
    };
  }
}
</script>